<template>

  <b-card no-body class="border-0">
    <b-btn v-b-toggle.collapse
           class="d-flex flex-row card-header p-3 align-items-center btn btn-outline-light shadow-sm active" >
      <i class="fas fa-sort-down"></i>
      <h4 class="mb-0">{{title}}</h4>
    </b-btn>
    <b-collapse id="collapse"
                :visible="collapsed"
                @show="togglleCollapse(true)"
                @hide="togglleCollapse(false)"
    >
      <slot name="text" class="p-3">
        <div class="p-3 help-text" v-html="text"></div>
      </slot>
    </b-collapse>
  </b-card>

</template>

<script>
  import i18n from "@/utils/i18n";

  export default {
    name: 'help',
    props: {
      title: {
        type: String,
        default: i18n.t('global.help')
      },
      text: {
        type: String,
        default: '',
      }
    },
    data () {
      return {
        collapsed: true
      }
    },
    created () {
      if (localStorage.getItem(`${this.$route.path}_help_collapsed`)) {
        this.collapsed = localStorage.getItem(`${this.$route.path}_help_collapsed`) === 'true'
      }
    },
    methods: {
      togglleCollapse (state) {
        localStorage.setItem(`${this.$route.path}_help_collapsed`, state);
      }
    }
  }
</script>